<template>
  <v-card>
    <v-card-title>
      Assignments
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="assignments"
      :items-per-page="15"
      class="elevation-1"
      :loading="loading_table"
      :search="search"
    >
      <template v-slot:item.date_start="{ item }">
        <span>{{ item.date_start | formatDate }}</span>
      </template>
      <template v-slot:item.venue_name="{ item }">
        <v-btn text color="primary" @click="goToAssignment(item.id)">{{ item.venue_name }}</v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import moment from 'moment'
import firebase from 'firebase/app'
import 'firebase/functions'

export default {
  data() {
    return {
      search: '',
      loading_table: true,
      assignments: [],
      headers: [
        {
          text: 'Venue',
          align: 'left',
          value: 'venue_name',
        },
        { text: 'Dates', value: 'date_start' },
        { text: 'Type', value: 'site_type' },
        { text: 'Assignment Type', value: 'type' },
        { text: 'Status', value: 'status' }
      ]
    }
  },
  methods: {
    goToAssignment(id) {
      this.$router.push({ name: 'assignment', params: { id: id } })
    }
  },
  filters: {
    formatDate: function(date) {
      return moment.utc(date).format('MM/DD/YYYY')
    }
  },
  mounted() {
    const vm = this
    const getVendorAssignments = firebase.functions().httpsCallable('getVendorAssignments')
    getVendorAssignments().then(function(response) {
      // console.log(response.data.result)
      // vm.assignments = response.data.result
      vm.assignments = Array.isArray(response.data.result) ? response.data.result : []
      vm.loading_table = false
    })
  }
}
</script>
